import {logJsError} from './api.service';
import {hexToRgb} from './utils.service';

class ThemeService {
	public init(primaryColor: string, accentColor: string, oems: string): void {
		this.initColors(primaryColor, accentColor);
		this.initOemTheme(oems);
	}

	private initColors(primaryColor: string, accentColor: string): void {
		if (!primaryColor) {
			logJsError({name: 'initColors failed', message: 'No primary color found', stack: 'themeService.tsx: 6'});
			return;
		}
		if (primaryColor && accentColor) {
			this.setCustomColorsCSS(primaryColor, accentColor);
		}
		// init from URL cannot be done from this file, as getFromStore can only be called from a hook in a functional component
		// const primaryColor = urlParam('primary_color');
		// const accentColor = urlParam('accent_color');
		// if (primaryColor && accentColor) {
		//     this.setCustomColorsCSS('#' + primaryColor, '#' + accentColor);
		// }
	}

	private setCustomColorsCSS(primaryColor: string, accentColor: string): void {
		const root = document.documentElement;
		root.style.setProperty('--primary-color', `${primaryColor}`);
		root.style.setProperty('--accent-color', `${accentColor}`);
		root.style.setProperty('--primary-color-rgb', `${hexToRgb(primaryColor)}`);
	}

	private initOemTheme(oems: string): void {
		if (!oems) {
			return;
		}
		const oem = oems.split(',')[0].replace(/\s+/g, '-');
		const body = document.body;
		body.classList.add(`${oem}-theme`);
	}
}

export const themeService = new ThemeService();
